// src/services/tenant.js
export const getTenantSlug = () => {
    const hostname = window.location.hostname

    // difatech.viaxii.com → 'difatech'
    // localhost → 'difatech' (para desarrollo)

    // localhost, 127.0.0.1 o una IP directa (p. ej. 192.168.x.x al probar desde
    // el celular en la red local) → entorno de desarrollo, usa el tenant de dev.
    const isIp = /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)
    if (hostname === 'localhost' || hostname === '127.0.0.1' || isIp) {
        return import.meta.env.VITE_DEV_TENANT ?? 'difatech'
    }

    const parts = hostname.split('.')

    // partes: ['difatech', 'viaxii', 'com']

    if (parts.length >= 3) return parts[0]

    return null  // viaxii.com sin subdominio → landing
}
